<template>
    <el-dialog
        :visible="dialogVisible"
        @close="handleClose"
        :title="$t('message.getattr.title')"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-form label-width="150px">
            <!-- 颜色分类 -->
            <el-form-item 
                :label="$t('message.getattr.form1')"
                v-show="!(color_attr == false)">
                <ul class="get_attr_list">
                    <li v-for="item in color_attr"
                        :key="item.id"
                        :class="{attr_select:item.goods_attr_id==selected_color}">
                        <a href="javascript:;"
                            @click="setColor(item.goods_attr_id)">
                            {{item.attr_value}}
                        </a>
                    </li>
                </ul>
            </el-form-item>
            <!-- 规格分类 -->
            <el-form-item 
                :label="$t('message.getattr.form2')"
                v-show="!(spec_attr == false)">
                <ul class="get_attr_list">
                    <li v-for="item in spec_attr"
                        :key="item.id"
                        :class="{attr_select:item.goods_attr_id==selected_spec}">
                        <a href="javascript:;"
                            @click="setSpec(item.goods_attr_id)">
                            {{item.attr_value}}
                        </a>
                    </li>
                </ul>
            </el-form-item>
            <!-- 订购数量 -->
            <el-form-item 
                :label="$t('message.getattr.form3')">
                <el-input-number 
                    v-model="num" 
                    :min="1"
                    :max="Number(goods.goods_number)">
                </el-input-number>
            </el-form-item>
            <!-- 提交按钮 -->
            <el-form-item>
                <!-- 提交 -->
                <el-button
                    type="primary"
                    @click="submitGoods">
                    {{$t("public.confirmBtn")}}
                </el-button>
                <!-- 取消 -->
                <el-button
                    @click="handleDialog(false)">
                    {{$t("public.cancelBtn")}}
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    data() {
        return {
            // 订购数量
            num: 1
        }
    },
    props: {
        url:{
            type: String,
            default: "/index/detail/cart"
        }
    },
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
        power: state => state.user.power,
        user_info: state => state.user.user_info,
        goods: state => state.goods.goods,
        spec_attr: state => state.goods.spec_attr,
        color_attr: state => state.goods.color_attr,
        selected_spec: state => state.goods.selected_spec,
        selected_color: state => state.goods.selected_color,
    }),
    methods: {
        ...mapMutations([
            "handleDialog",
            "setColor", // 写入选中颜色
            "setSpec", // 写入选中规格
        ]),
        ...mapActions([
            "handleAddCart",
        ]),
        handleClose(){
            this.handleDialog(false);
            this.setColor(null);
            this.setSpec(null);
            this.num = 1;
        },
        submitGoods(){ // 提交请求
            // 判断是否选中属性
            if(!(this.color_attr == false) && !this.selected_color){
                this.$message({
                    message: this.$t("message.getattr.errmsg1"),
                    type: "warning",
                    center: true,
                })
                return
            }else if (!(this.spec_attr == false) && !this.selected_spec){
                this.$message({
                    message: this.$t("message.getattr.errmsg2"),
                    type: "warning",
                    center: true,
                })
                return
            }

            let top_level = this.power.includes(0) || this.power.includes(111),
            cart_level = top_level || this.power.includes(7),
            qcart_level = top_level || this.power.includes(6);
            if(this.url.indexOf("quote_cart")>=0 &&  !qcart_level){
                this.$message({
                    showClose: true,
                    message: this.$t("public.authorityQuote"),
                    type: "error"
                })
                return
            }else if(this.url.indexOf("/cart")>=0 && !cart_level){
                this.$message({
                    showClose: true,
                    message: this.$t("public.authorityOrder"),
                    type: "error"
                })
                return
            }
            this.handleAddCart({
                user_id: this.user_info.id,
                goods_id: this.goods.goods_id,
                goods_number: this.num,
                goods_attr_id: this.selected_color,
                goods_specification_id: this.selected_spec,
                url: this.url
            }).then((res) => {
                if(res.type == 1){
                    this.$message({
                        showClose: true,
                        message: this.$t("public.addSucc"),
                        type: "success",
                        center: true
                    });
                }else if(res.type == 2){
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: "error",
                        center: true
                    });
                }else if(res.type == 5){
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: "error",
                        center: true
                    });
                }
                this.handleDialog(false)
            })
        }
    },
}
</script>

<style scoped>
/* 属性列表 */
.get_attr_list>li{
    float: left;
    margin:0 10px 5px 0;
}
.get_attr_list>li>a{
    display: inline-block;
    padding:0px 30px;
    background-color:#F2F6FC;
    border: 1px solid #E4E7ED;
    border-radius: 5px;
    color: #606266;
}
.get_attr_list>li.attr_select>a{
    background-color: #ff6700;
    color: #fff;
}
</style>
